import { FullPageLoader } from '@sketchnote/shared-components';
import { useRouter } from 'next/router';
import { useSession } from 'next-auth/client';
import { useEffect } from 'react';
import * as React from 'react';
import { ErrorPage } from 'src/components/error-pages/ErrorPage';
import { NoAccessPage } from 'src/components/error-pages/NoAccessPage';
import { useAuth } from 'src/shared/hooks/use-auth';
const { useMemo } = React;

export const withAuth = (Component) => {
  const Wrapper = () => {
    const [session, loading]: any = useSession();
    const { accessToken, setAccessToken, setUserDetails, setOrgId } = useAuth((state) => ({
      accessToken: state.accessToken,
      setAccessToken: state.setAccessToken,
      setUserDetails: state.setUserDetails,
      setOrgId: state.setOrgId,
    }));

    const authData = useAuth((s) => s.userDetails);
    const isOnboardingComplete = useAuth((s) => s.isOnboardingComplete);
    const router = useRouter();
    const fetchUserDetails = useAuth((s) => s.fetchUserDetails);

    const currentOrganisation = useMemo(() => {
      if (router.query.orgId && authData) {
        return authData?.organisations?.filter(
          (item) => item.organisationId === router?.query?.orgId
        )[0];
      }
    }, [router?.query?.orgId, authData]);

    useEffect(() => {
      if (!loading && !session?.accessToken) {
        setUserDetails(null);
        router.push('/signin');
      }
      if (session?.accessToken && session.accessToken !== accessToken) {
        setAccessToken(session.accessToken);
      }
    }, [session, loading, accessToken]);

    useEffect(() => {
      setOrgId(router?.query?.orgId as string);
    }, [session, router?.query?.orgId]);

    useEffect(() => {
      if (accessToken) {
        fetchUserDetails();
      }
    }, [accessToken]);

    useEffect(() => {
      if (authData?.authentication === 'unAuthorised') {
        setUserDetails(null);
        router.push('/signin');
      } else if (authData?.authentication === 'userInfoPending' && !isOnboardingComplete) {
        router.push('/signup/user-info');
      }
    }, [authData?.authentication]);

    //2001 when user is not a member of the organisation
    if (authData?.errorCode === 2001) return <NoAccessPage type="organisation" />;
    //1009 generic error code
    else if (authData?.errorCode === 2000) return <ErrorPage />;
    else if (authData?.authentication === 'authorised') {
      if (currentOrganisation) return <Component />;
      return <NoAccessPage />;
    }

    return <FullPageLoader loading={true} />;
  };
  Wrapper.layout = Component.layout;
  return Wrapper;
};
export default withAuth;
